//#region Imports

import { Injectable } from '@angular/core';
import { getErrorMessage } from '../../utils/functions';
import { QuizProgressPayload } from '../../models/payloads/progress/quiz-progress.payload';
import { CrudRequestParams } from '../../utils/crud';
import { UserProgressProxy } from '../../models/proxies/user-progress.proxy';
import { AuthService } from '../auth/auth.service';
import { UserProgressInteractor } from '../../interactors/user-progress/user-progress.interactor';
import { UserProgressCourseProxy } from '../../models/proxies/user-progress-course.proxy';

//#endregion

@Injectable({
  providedIn: 'root',
})
export class UserProgressService {

  //#region Constructor

  constructor(
    private readonly auth: AuthService,
    private readonly interactor: UserProgressInteractor,
  ) {}

  //#endregion

  //#region Public Methods

  public async getMyProgresses(
    params: CrudRequestParams<UserProgressProxy>
  ): Promise<[UserProgressProxy[] | null, string?]> {
    const currentUser = this.auth.getCurrentUser();

    if (!currentUser)
      return [
        null,
        $localize`Você não está autenticado na plataforma, logo, não é possível visualizar as informações da aula.`,
      ];

    params =  {
      search: {
        ...params.search,
        userId: currentUser.id,
      }
    }

    const { error, success } = await this.interactor.getMany(params);

    if (error || !success) return [null, getErrorMessage(error)];

    return [success];
  }

  public async createQuizProgress(payload: QuizProgressPayload): Promise<[QuizProgressPayload | null, string?]> {
    const { success, error } = await this.interactor.createQuizProgress(payload);

    if (error || !success) return [null, getErrorMessage(error)];

    return [success];
  }

  public async updateQuizProgress(
    entityId: string, payload: QuizProgressPayload
  ): Promise<[QuizProgressPayload | null, string?]> {
    const { success, error } = await this.interactor.updateQuizProgress(entityId, payload);

    if (error || !success) return [null, getErrorMessage(error)];

    return [success];
  }

  public async getUserProgress(courseId: string): Promise<[UserProgressCourseProxy | null, string?]> {
    const { success, error } = await this.interactor.getUserProgress(courseId);
   
    if (error || !success) return [null, getErrorMessage(error)];

    return [success];
  }

  //#endregion

}
